<script>
export default {
    mounted() {
        this.$nextTick(() => {
            let loggedIn = this.$auth.storeTokens();
            if (loggedIn) window.location.href = '/';
            else window.location.href = this.$auth.getLoginURL();
        });
    },
};
</script>
